export default __webpack_public_path__ + "d7ff84b928d5d125d33b8c6f0cfc64e5.svg";